import { useEffect, useState } from "react";

// Pick the background matching the visitor's screen: <768px = mobile,
// 768–1279px = tablet, ≥1280px = PC. Falls back to the default (PC) image.
export function useResponsiveBackground(game) {
  const [width, setWidth] = useState(() => window.innerWidth);
  useEffect(() => {
    const onResize = () => setWidth(window.innerWidth);
    window.addEventListener("resize", onResize);
    return () => window.removeEventListener("resize", onResize);
  }, []);
  if (!game) return null;
  if (width < 768)
    return game.background_image_mobile || game.background_image;
  if (width < 1280)
    return game.background_image_tablet || game.background_image;
  return game.background_image;
}
